import type { ReactNode } from 'react';

import { AuthContextProvider } from '@/auth/AuthContext';
import { AuthProviderWithRouter } from '@/auth/AuthProvider';
import { E2eAuthProvider } from '@/auth/E2eAuthProvider';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { ApiProvider } from '@/lib/api-context';
import { AppRoutes } from '@/routing/routes';
import { ThemeProvider } from '@/theme/ThemeContext';

// Build-time constant. In production `VITE_E2E_AUTH` is unset, so this is
// `false` and the entire e2e branch (incl. the E2eAuthProvider import) is
// dead-code-eliminated from the bundle.
const E2E_AUTH = import.meta.env.VITE_E2E_AUTH === '1';

/** Real Auth0-backed auth wrapper used in every non-e2e build. */
function RealAuth({ children }: { children: ReactNode }) {
  return (
    <AuthProviderWithRouter>
      <AuthContextProvider>{children}</AuthContextProvider>
    </AuthProviderWithRouter>
  );
}

export function App() {
  const AuthWrapper = E2E_AUTH ? E2eAuthProvider : RealAuth;
  return (
    <ErrorBoundary>
      <ThemeProvider>
        <AuthWrapper>
          <ApiProvider>
            <AppRoutes />
          </ApiProvider>
        </AuthWrapper>
      </ThemeProvider>
    </ErrorBoundary>
  );
}
